import React from 'react';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import Duration from '@/types/models/pricing/duration';
import {SubscriptionPlan} from '@/types/models/pricing/subscriptionPlan';
import {getPriceCurrency} from '@/views/content-studio/pricing/utils';

type PriceFootnoteProps = {
  selectedDuration: Duration;
  selectedSubscriptionPlan: SubscriptionPlan;
  className?: string;
};

function PriceFootnote({
  selectedDuration,
  selectedSubscriptionPlan,
  className,
}: PriceFootnoteProps) {
  const DurationFootnote =
    selectedDuration === Duration.YEARLY
      ? `${
          selectedSubscriptionPlan.yearlyPrice
            ? getPriceCurrency(
                selectedSubscriptionPlan.currency,
                selectedSubscriptionPlan.yearlyPrice
              )
            : ''
        } ${translate('Billed annually')}`
      : translate('Billed monthly');
  return (
    <Body size="md" className={className}>
      {DurationFootnote}
    </Body>
  );
}

export default PriceFootnote;
